import { render, staticRenderFns } from "./ChatOrderVariable.vue?vue&type=template&id=78c3d6ec&scoped=true&"
import script from "./ChatOrderVariable.vue?vue&type=script&lang=js&"
export * from "./ChatOrderVariable.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderVariable.vue?vue&type=style&index=0&id=78c3d6ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c3d6ec",
  null
  
)

export default component.exports